import React, {useMemo} from 'react'
import {useSelector} from 'react-redux'

import useKeyListener from 'hooks/key_listener'
import type {RootState} from 'store/actions'

import Textarea from 'components/textarea'
import {Modal, useModal} from './modal'


type Props = Omit<React.ComponentProps<typeof Modal>, 'isShown'|'onClose'|'children'>

const DebugModal = ({style: parentStyle, ...props}: Props): React.ReactElement => {
  const [isShown, show, onClose] = useModal()
  useKeyListener('KeyE', show, {ctrl: true, shift: true})
  const user = useSelector(({user}: RootState) => user)
  const userJson = useMemo(
    () => isShown ? JSON.stringify(user, undefined, 2) : '',
    [isShown, user])

  const style = useMemo((): React.CSSProperties => ({
    display: 'flex',
    flexDirection: 'column',
    height: '80%',
    width: '80%',
    ...parentStyle,
  }), [parentStyle])
  return <Modal isShown={isShown} onClose={onClose} {...props} style={style}>
    <Textarea
      style={{flex: 1, fontFamily: 'Monospace', fontSize: 12}} readOnly={true}
      value={userJson} />
  </Modal>
}


export default React.memo(DebugModal)
